import React, { useState, useEffect } from "react";
import { Space, Table, Tag, Select,Flex } from 'antd';
import { Link } from "react-router-dom";
import fetchData from "Hooks/useAPI";
import './style.css'
import useAuth from "Hooks/useAuth";



const TableWithPaginationAndApi = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dataSource, setDataSource] = useState([]);
  const [empresa, setEmpresa] = useState("all")
  const [totalData, setTotalData] = useState(0);
  const { logout } = useAuth()
  const URL = `https://adandyou.host/users_app/api/index.php/ventanuevo?pagina=${currentPage}&porPagina=${pageSize}&empresa=${empresa}`

  useEffect(() => {
    fetchData(URL, 'GET', null, {}, logout)
    .then(response=>{
      setDataSource(response.items.data);
      setTotalData(response.items.total);
    })
    .catch((err)=>{
      console.log(err)
    })
    
  }, [currentPage, pageSize,empresa]);

  const columns = [
    {
      title: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
    },
    {
      title: 'Tarifa',
      dataIndex: 'tarifa',
      key: 'tarifa',
    },
    {
      title: 'Empresa',
      dataIndex: 'empresa',
      key: 'empresa',
    },
    {
      title: 'Fecha',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Acciones',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Link className="menu-link" to={`/admin/invoice/${record.tarifa}/${record.folio}/${record.empresa}`}>Facturación</Link>
          <Link target="_blank" className="menu-link" to={`https://detalle.mitaxiaeropuerto.com/public/ticket/${record.folio}`}>Detalle</Link>
        </Space>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <Flex vertical gap={"middle"}>
      <Select
        showSearch
        placeholder="Empresa"
        optionFilterProp="label"
        onChange={(v)=>{
          setEmpresa(v)
        }}
        options={[
          {
            value: "all",
            label: 'TODOS',
          },
          {
            value: 'spasa',
            label: 'SPASA',
          },
          {
            value: 'cdmx',
            label: 'TAXIS NUEVAIMAGEN',
          },
        ]}
      />
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalData,
          onChange: handlePageChange,
        }}
      />
    </Flex>
  );
};



export default TableWithPaginationAndApi;